__turbopack_context__.v({
  "hidden": "reviews-tabs-module-scss-module__kqQT1a__hidden",
  "info-tooltip-trigger": "reviews-tabs-module-scss-module__kqQT1a__info-tooltip-trigger",
  "reviews-title": "reviews-tabs-module-scss-module__kqQT1a__reviews-title",
  "reviews-title-spacing": "reviews-tabs-module-scss-module__kqQT1a__reviews-title-spacing",
  "tab-content": "reviews-tabs-module-scss-module__kqQT1a__tab-content",
});
